import { render, staticRenderFns } from "./DemandeReconnaissanceArmFranceQuebec.vue?vue&type=template&id=4c39bb1a"
import script from "./DemandeReconnaissanceArmFranceQuebec.vue?vue&type=script&lang=js"
export * from "./DemandeReconnaissanceArmFranceQuebec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports